module.exports = __webpack_public_path__ + "img/cell.971a632f.jpg";